module.exports = __webpack_public_path__ + "media/images/logo-white-full-7acf40f5e9dc9b7db668bd95eeb1dda5.png";